module.exports = function(service) {
	'use strict'
	service.factory('reverseWpautop', reverseWpautop);
	reverseWpautop.$inject = [];
	function reverseWpautop() {
	   	return function(content) {
			// This removes leading empty paragraphs but keeps content-separating ones
			content = content.replace(/^(<p[^>]*>\s*(?:&nbsp;|\s)*<\/p>\s*)+/gi, "");
			// Replace <br> and <br /> with newlines
			content = content.replace(/<br>|<br \/>/g, "\n");
			content = content.replace(/<br data-mce-bogus="1">/g,"");
			// content = content.replace(/<\/blockquote>/g,'</blockquote>\n\n');

			// Special handling for HR tags - ensure double newlines for wpautop
			content = content.replace(/<\/p>\s*(<hr[^>]*>)/g, '\n\n$1'); // Before HR
			content = content.replace(/(<hr[^>]*>)\s*<p>/g, '$1\n\n'); // After HR
			content = content.replace(/(<hr[^>]*>)([^\n])/g, '$1\n\n$2'); // Catch any remaining text after HR

			content = content.replace(/<p [\s\w"\=-]*id="edit-image"[\s\w"\=-]*>[\s\w]*<\/p>/g,"<p></p>");
			content = content.replace(/<p([^>]*)><\/p>/g,"");
			content = content.replace(/<p([^>]*)><\/p>/g,"");
			content = content.replace(/<p>/gmi, "");
		   	content = content.replace(/<p ([^>]*)>/gmi, "");
			content = content.replace(/<\/p>/g, "\n\n");
			// content = content.replace(/(?<!&nbsp;)&nbsp;(?!&nbsp;)/g, " ");
			// if(navigator.userAgent.toLowerCase().indexOf('firefox') > -1 ){
			// 	console.log(content);
   //   			content = content.replace(/\n/g, "\r\n").replace(/\r\r/g, "\r");
   //   			console.log('firerox')
   //   			console.log(content);
			// } 
			var html_entity_decode = function (str){
			  	var ta=document.createElement("textarea");
			  	ta.innerHTML=str;
			  	return ta.value;
			}
			content = html_entity_decode(content)
	        return content;
	   }
	}
}


//////////////////
// WEBPACK FOOTER
// ./public/development/assets/ext-modules/servicesModule/services/reverseWpautopService.js
// module id = 625
// module chunks = 0